import EditBillingGroup from '../components/templates/edit-billing-group';

export const EditBillingGroupContainer = () => {
  return <EditBillingGroup />;
};
